module.exports = __webpack_public_path__ + "static/img/14994016861.39a76a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/14994016861.jpg
// module id = jaa0
// module chunks = 0